import { render, staticRenderFns } from "./IsRemark.vue?vue&type=template&id=cbd29cce&scoped=true"
import script from "./IsRemark.vue?vue&type=script&lang=js"
export * from "./IsRemark.vue?vue&type=script&lang=js"
import style0 from "./IsRemark.vue?vue&type=style&index=0&id=cbd29cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd29cce",
  null
  
)

export default component.exports